import { z } from 'zod';

/**
 * Field-level masking metadata. The Zod enum is authoritative; the TS union
 * and the runtime set are derived from it so they cannot drift out of sync.
 */

export const MaskableFieldKeySchema = z.enum([
  'email',
  'name',
  'linkedinEmail',
  'phoneNumber',
  'resumeKey',
  'resumeContent',
  'answerBankValues',
  'affectedUserIds',
]);
export type MaskableFieldKey = z.infer<typeof MaskableFieldKeySchema>;

export const MASKABLE_FIELDS: ReadonlySet<MaskableFieldKey> = new Set(
  MaskableFieldKeySchema.options,
);

export function isMaskableField(value: string): value is MaskableFieldKey {
  return (MASKABLE_FIELDS as ReadonlySet<string>).has(value);
}
